import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";

import { DataProvider } from "@refinedev/core";
import fnlAPI from "../../../../api/fnl-axios-instance";

export const mappingPariDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = fnlAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async ({ resource, sort, meta }) => {
      const url = "/api/v1/cms/pari/teams";

      try {
        const { data } = await httpClient.get(`${url}`);
        return {
          data,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: async ({
      resource,
      meta,
      variables,
    }: {
      meta: {
        melbetTeam: string;
        fnlTeam: string;
      };
      resource: string;
      variables: {
        fnlTeam: string;
      };
    }) => {
      const url = "/api/v1/cms/update-pari/teams";

      const { melbetTeam, fnlTeam } = meta;
      try {
        await httpClient.post(url, {
          melbetTeam,
          ...variables,
          fnlTeam,
        });

        return Promise.resolve();
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
